import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

import './Page.scss';
import { IOperationData, IPageType } from "../../../constants/types";

import TemplatePage from "../templatePage/TemplatePage";
import Icon from '../../icon/Icon';
import Operation from "../../operations/Operation";
import eventBus from "../../operations/EventBus"

interface Props extends WithTranslation {
    pageType: IPageType,
    data: IOperationData,
    onUndo?: () => void,
    onChange: (changes: IOperationData) => void,
    onNext: () => void
};

class Page extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    needsValidation = () => {
        const { onNext } = this.props;
        eventBus.dispatch("onNextValidate", onNext);
    }

    render() {
        const { pageType, data, onUndo, onChange, onNext } = this.props;
        let sOnNext = pageType.operation.type === "LIST-TEXT-INPUT" ? this.needsValidation : onNext;

        return <TemplatePage id={pageType.id} title={pageType.title} onUndo={onUndo} nextEnabled={data.OK} onNext={sOnNext}>
            <Operation operation={pageType.operation} data={data} onChange={onChange} />
        </TemplatePage>;
    }
};

export default withTranslation()(Page);